import { CentralLoadingIndicator, GvPrimaryButton } from "../../../components";
import React, { useEffect, useState } from "react";

import { CloseIcon } from "../../../components/Icons";
import { MODALS } from "../../../config/params";
import { getContactString } from "../../containers/ChangeHospitalContainer/ChangeHospitalContainer";
import useChangeLocation from "../../../services/edit-hospital-location/edit-hospital-location-mutation";
import { useModal } from "../../../context/ModalContext";
import { useUpdateLocationStore } from "../../../hooks/redux-hooks/updateLocation-store/updateLocation-store";

const UpdateHospitalErrorModal = () => {
  const { openModal, closeModal } = useModal();
  const { locationSelected } = useUpdateLocationStore();
  const { changeHospitalLocation, updatedLocation, error, loading } = useChangeLocation();
  const [currentLocationContact, setCurrentLocationContact] = useState<string>("");


  const handleCloseIcon = () =>{
    closeModal();
  };
  const handleTryAgain = () =>{
    setCurrentLocationContact(getContactString(locationSelected[0].phoneNumber));
    if (locationSelected) {
      changeHospitalLocation( { locationId: locationSelected[0].idLocation });
    }
  };

  useEffect(() => {
    if (updatedLocation) {
      openModal(MODALS.UPDATE_HOSPITAL);
    }
  }, [updatedLocation]);

  if (loading) {
    return <CentralLoadingIndicator />;
  };


  return (
    <div className="relative flex flex-col justify-between h-[95%] gap-4 p-2">

      <div>
        <div onClick={handleCloseIcon} className="flex justify-end cursor-pointer">
          <CloseIcon width = {20} height = {20} />
        </div>
        <div className="text-xl font-semibold text-center geograph-regular">
        Change Home Hospital
        </div>
      </div>

      <div className="h-[80%] overflow-y-auto flex flex-col justify-between items-center py-6 pe-2">
        <div className="flex-grow flex flex-col gap-4 items-center">
          <div><img src="/assets/icons/updateHospitalError.png" alt="warning_img" height={170} width={170}/></div>
          <div className="flex flex-col gap-2 items-center">
            <div className="font-semibold">Oops...something went wrong!</div>
            <div className="text-sm text-center">
              We ran into an error while transferring your account to your new hospital{" "}
              <span className="font-semibold capitalize">{locationSelected[0].locationName}</span>
            </div>
          </div>
        </div>
        {!error ?
          <div className="text-sm">Try again below to give it one more shot.</div>:
          <div className="text-sm flex flex-col items-center gap-2">
            <div className="text-center">
            Please contact{" "}
              <span className="font-semibold capitalize">{locationSelected[0].locationName}</span>{" "}
            directly to change your hospital and book your next appointment
            </div>
            <div className="text-gv-gold font-semibold">
              {locationSelected[0].phoneNumber}
            </div>
          </div>}
      </div>

      {!error ? <div className="w-full">
        <GvPrimaryButton
          onClick={handleTryAgain}
          className="!h-[2.3rem]"
          type="button">
          <div className="normal-case font-semibold text-xs text-center">Try Again</div>
        </GvPrimaryButton>
      </div>:
        <GvPrimaryButton
          className="!h-[2.3rem]"
          type="button">
          <a href={currentLocationContact} className="normal-case font-semibold text-sm text-center">Contact</a>
        </GvPrimaryButton>}
    </div>
  );
};

export default UpdateHospitalErrorModal;
